import * as React from "react"

interface IMockBarChart {
  transform?: string
  style?: React.CSSProperties
}

export const MockBarChart = (props: IMockBarChart) => (
  <svg
    width="392"
    height="222"
    viewBox="0 0 392 222"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect y="64" width="65" height="158" fill="#FF9E1B" />
    <rect x="109" width="65" height="222" fill="#CF4520" />
    <rect x="327" y="59" width="65" height="163" fill="#51284F" />
    <rect x="226" y="152" width="66" height="70" fill="#719949" />
  </svg>
)
